export enum OrderManualStatusEnum {
  AwaitingAuthorisations = 'Awaiting authorisations',
}